import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm z-50 border-b border-gray-200">
      <nav className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <h1>
              <button 
                onClick={scrollToTop}
                className="flex items-center gap-3 hover:opacity-70 transition-opacity cursor-pointer"
              >
                <img 
                  src="https://static.readdy.ai/image/dc94b4331bde31366815bfe78425789e/ee77cd5e24359f194577e6ccca300426.png" 
                  alt="Nowest ロゴ" 
                  className="h-10 w-auto object-contain"
                />
                <span className="text-2xl font-semibold text-primary">Nowest</span>
              </button>
            </h1>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-10">
            <button
              onClick={() => scrollToSection('services')}
              className="text-secondary hover:text-primary transition-colors font-medium whitespace-nowrap cursor-pointer"
            >
              事業内容
            </button>
            <Link
              to="/features"
              className="text-secondary hover:text-primary transition-colors font-medium whitespace-nowrap cursor-pointer"
            >
              特徴
            </Link>
            <Link
              to="/about"
              className="text-secondary hover:text-primary transition-colors font-medium whitespace-nowrap cursor-pointer"
            >
              会社概要
            </Link>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-primary text-white px-6 py-2.5 hover:bg-accent transition-colors font-medium whitespace-nowrap cursor-pointer"
            >
              お問い合わせ
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-primary hover:opacity-70 transition-opacity cursor-pointer"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('services')}
                className="text-secondary hover:text-primary transition-colors font-medium text-left cursor-pointer"
              >
                事業内容
              </button>
              <Link
                to="/features"
                className="text-secondary hover:text-primary transition-colors font-medium cursor-pointer"
              >
                特徴
              </Link>
              <Link
                to="/about"
                className="text-secondary hover:text-primary transition-colors font-medium cursor-pointer"
              >
                会社概要
              </Link>
              <button
                onClick={() => scrollToSection('contact')}
                className="bg-primary text-white px-6 py-2.5 hover:bg-accent transition-colors font-medium text-center whitespace-nowrap cursor-pointer"
              >
                お問い合わせ
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
